import styled from '@emotion/styled';
import { Button, MenuGroupHeader } from '@fluentui/react-components';

export const SectionHeaderContainer = styled.span`
  display: flex;
  justify-content: space-between;
  padding-right: 0;
`;

export const SectionHeaderGroupHeader = styled(MenuGroupHeader)`
  text-transform: uppercase;
`;

export const SectionHeaderButton = styled(Button)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 0;
  .Button__icon {
    margin-left: 0;
  }
`;

export const MenuItemNotInteractive = styled.div`
  padding: 6px;
`;
